import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { DisplayValue } from '../../mapping/entity-display.model';

/** One cell's value drawn by its column type; `null` is a cell the row has no value for: the empty marker. */
@Component({
    standalone: true,
    selector: 'p-ai-chat-draft-field-value',
    imports: [TranslateModule, PIconModule],
    templateUrl: './draft-field-value.component.html',
    styleUrl: './draft-field-value.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraftFieldValueComponent {
    public readonly value = input.required<DisplayValue | null>();
}
